import MdEmptyState from "./MdEmptyState"

const MdEmptyStatePlugin = {
  install(app) {
    app.component(MdEmptyState.name, MdEmptyState)
  },
}

export default MdEmptyStatePlugin
